export enum ChangeRequestDomain {
  PRODUCT = "product",
  GROUP = "group",
  MODIFIER = "modifier",
  MODIFIER_GROUP = "modifier_group",
  UNIT = "unit",
  PREP_STATION = "prep_station",
  BOOKKEEPING_ACCOUNT = "bookkeeping_account",
  FLOOR_PLAN = "floor_plan",
  LAYOUT = "layout",
  PRODUCT_PAGE = "product_page",
  STORE_SETTINGS = "store_settings",
  ONLINE_ORDER_SETTINGS = "online_order_settings",
  DEVICE_CONFIG = "device_config",
  PAYMENT_METHOD = "payment_method",
  PRINTER = "printer",
  COURSE = "course",
  OFFER = "offer",
  SUPPLIER = "supplier",
}
